import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ENUM_THEMES, THEMES } from '../../../shared/helpers/app.constants';
import { ThemesSettingsService } from '../../../shared/services/themes-settings.service';

@Component({
  selector: 'app-themes-settings',
  templateUrl: './themes-settings.component.html',
  styleUrls: ['./themes-settings.component.scss']
})
export class ThemesSettingsComponent implements OnInit {
  themesOptions: any[] = THEMES;

  form: FormGroup;

  constructor(
    private themesSettingsService: ThemesSettingsService
  ) { }

  get themes() {
    return this.form.controls.themes;
  }

  ngOnInit(): void {
    const localData = this.themesSettingsService.getLocalStorage();
    this.createForm(localData);
  }

  private createForm(data: Partial<any>): void {
    data = data || {};
    this.form = new FormGroup({
      themes: new FormControl(data.themes || ENUM_THEMES.Light)
    });
  }

  onChangeThemesOption(eventData) {
    if (eventData && eventData.id) {
      this.themes.setValue(eventData.id);
      // set theme ui
      if (eventData.id === ENUM_THEMES.Dark) {
        if (document.body.classList.value.toString().indexOf('frac-dark-theme') === -1) document.body.classList.add('frac-dark-theme');
      } else {
        document.body.classList.remove('frac-dark-theme');
      }
      // Set local storage
      const dataState = this.getState();
      this.setState(dataState);
    }
  }

  private setState(dataState): void {
    this.themesSettingsService.setDataState(dataState);
    this.themesSettingsService.setLocalStorage(dataState);
  }

  private getState() {
    if (!this.form) return null;
    // note that: formGroup doesn't support ui-switch with custom ngModel
    const dataState = this.form.getRawValue();
    return dataState;
  }
}